import { Fragment, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Image, Switch, Button, Input, Table, Modal, Space, Form, Select, Checkbox, message, Typography, InputNumber } from 'antd';
import {
    getConferenceIdentitySuppliesApi,
    updateConferenceIdentitySuppliesApi,
    deleteConferenceIdentitySuppliesApi,
    saveConferenceIdentitySuppliesApi,
    getActivityIdentitiesApi,
    saveActivityidentitiesApi,
    updateActivityidentitiesApi,
    deleteActivityidentitiesApi,
    activityregistrationsApi,
    deleteActivityregistrationsApi,
    getChannelListApi,
    getwxacodeApi,
    getDowloadWxacodeApi,
} from '@services/Conference';
import './index.less';
import config from '@config';
import { DefaultChannel } from '../../../constants';

const { Text } = Typography;

const pageFormItemLayout = {
    labelCol: {
        sm: { span: 5 },
        lg: { span: 4 },
        xl: { span: 5 },
    },
    wrapperCol: {
        sm: { span: 17 },
        lg: { span: 19 },
        xl: { span: 17 },
    },
};

//报名设置
const SignUpSetting = () => {
    const navigate = useNavigate();
    const params = useParams();
    const cid = ~~params?.id;
    const [form] = Form.useForm();
    const [equityForm] = Form.useForm();
    const [channelForm] = Form.useForm();
    const [addDentity, setAddDentity] = useState(false);
    const [addEquity, setAddEquity] = useState(false);
    const [data, setData] = useState([]);
    const [type, setType] = useState();
    const [signTitle, setSignTitle] = useState('');
    const [generateChannelOpen, setGenerateChannelOpen] = useState(false);
    const [activityidentities, setActivityidentities] = useState([]);
    const [activityRegistrations, setActivityRegistrations] = useState([]);
    const [channelList, setChannelList] = useState([]);
    const [currentIdentity, setCurrentIdentity] = useState({});

    const channelId = Form.useWatch('channelId', channelForm);
    const [wxacode, setWxacode] = useState('');

    const signColumns = [
        {
            title: '权益ID',
            dataIndex: 'id',
            key: 'id',
            width: 88,
        },
        {
            title: '权益名称（对外展示）',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '数量',
            dataIndex: 'amount',
            key: 'amount',
            width: 120,
            render: (_, row) => {
                return row.amount || <Text type="danger">未配置</Text>;
            },
        },
        {
            title: '权益状态',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (_, record) => <Switch checkedChildren="开启" unCheckedChildren="关闭" defaultChecked checked={record.enabled} onChange={checked => onChangeSignStatus(record, checked)} />,
        },
        {
            title: '操作',
            dataIndex: 'operations',
            key: 'operations',
            width: 120,
            render: (_, row) => {
                return (
                    <span className="operation-btns" style={{ display: 'flex' }}>
                        <Button size="small" type="link" onClick={() => handleAddEquity('edit', row)}>
                            编辑
                        </Button>
                        <Button size="small" type="link" disabled={row.createdBy === '系统'} onClick={() => handleDeleteEquity(row)}>
                            删除
                        </Button>
                    </span>
                );
            },
        },
    ];

    const templateColumns = [
        {
            title: '模板ID',
            dataIndex: 'id',
            key: 'id',
            width: 88,
        },
        {
            title: '模板名称',
            dataIndex: 'name',
            key: 'name',
            width: 200,
        },
        {
            title: '报名身份及权益',
            dataIndex: 'benefits',
            key: 'benefits',
            render: (_, row) => {
                const list = row.identitiesEntities;
                return (
                    <>
                        {list
                            && !!list.length
                            && list.map((item, index) => (
                                <div key={index}>
                                    {item.name}：{item.benefits ? JSON?.parse(item.benefits).map((i, idx) => <span key={idx} style={{ paddingRight: 10 }}>{`${i.name}*${i.amount}`}</span>) : <Text type="secondary">&ndash;</Text>}
                                </div>
                            ))}
                    </>
                );
            },
        },
        {
            title: '联系人',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (_, row) => {
                return JSON.parse(row.regContacts || '[]').length ? (
                    JSON.parse(row.regContacts).map((i, idx) => {
                        return (
                            <div key={idx} style={{ paddingRight: 10 }}>
                                {i.name}
                            </div>
                        );
                    })
                ) : (
                    <Text type="secondary">未添加</Text>
                );
            },
        },
        {
            title: '创建人',
            dataIndex: 'createdByName',
            key: 'createdByName',
            width: 100,
            render: (_, record) => <>{record.createdByName || '系统'}</>,
        },
        {
            title: '操作',
            dataIndex: 'operations',
            key: 'operations',
            width: 200,
            render: (_, row) => {
                return (
                    <span className="operation-btns" style={{ display: 'flex' }}>
                        <Button size="small" type="link" onClick={() => handleGenerateChannel(row)}>
                            生成渠道码
                        </Button>
                        <Button size="small" type="link" onClick={() => handleAddTemplate('edit', row)}>
                            编辑
                        </Button>
                        <Button size="small" type="link" disabled={row.createdBy === '系统'} onClick={() => handleDeleteTemplate(row)}>
                            删除
                        </Button>
                    </span>
                );
            },
        },
    ];

    const columns = [
        {
            title: '身份ID',
            dataIndex: 'id',
            key: 'id',
            width: 88,
        },
        {
            title: '身份名称',
            dataIndex: 'name',
            key: 'name',
            width: 120,
        },
        {
            title: '身份权益',
            dataIndex: 'benefits',
            key: 'benefits',
            render: (_, row) => {
                return row.benefits
                    ? JSON?.parse(row.benefits).map((i, idx) => {
                          return <span key={idx} style={{ paddingRight: 10 }}>{`${i.name}*${i.amount}`}</span>;
                      })
                    : '';
            },
        },
        {
            title: '说明',
            dataIndex: 'identityDesc',
            key: 'identityDesc',
            width: 300,
        },
        {
            title: '创建人',
            dataIndex: 'createdBy',
            key: 'createdBy',
            width: 100,
        },
        {
            title: '操作',
            dataIndex: 'operations',
            key: 'operations',
            width: 120,
            render: (_, row) => {
                return (
                    <span className="operation-btns" style={{ display: 'flex' }}>
                        <Button size="small" type="link" onClick={() => handleAdd('edit', row)}>
                            编辑
                        </Button>
                        <Button size="small" type="link" disabled={row.createdBy === '系统'} onClick={() => handleDelete(row)}>
                            删除
                        </Button>
                    </span>
                );
            },
        },
    ];

    // 切换权益状态
    const onChangeSignStatus = async (record, checked) => {
        const res = await updateConferenceIdentitySuppliesApi({
            id: record.id,
            enabled: checked ? 1 : 0,
            activityType: 'conference',
            activityId: cid,
        });
        if (res && res.status_code === 200) {
            message.success('操作成功');
            getConferenceIdentitySupplies();
        }
    };

    // 身份列表
    const getSuppliesPage = (type, value) => {
        getConferenceIdentitySuppliesApi({ activityId: cid, activityType: 'conference', enabled: 1 }).then(res => {
            if (res && res.status_code === 200) {
                if (type === 'add') {
                    const arr = res?.data.map(i => {
                        return {
                            id: i.id,
                            name: i.name,
                            check: true,
                            amount: 1,
                        };
                    });
                    form.setFieldValue('benefits', arr);
                    setAddDentity(true);
                } else if (type === 'edit') {
                    const arr = res?.data.map(i => {
                        return {
                            id: i.id,
                            name: i.name,
                            check: false,
                            amount: 1,
                        };
                    });

                    const { name, benefits, identityDesc, id } = value;
                    const arr1 = benefits
                        ? JSON.parse(benefits).map(i => {
                              return {
                                  id: i.id,
                                  name: i.name,
                                  check: true,
                                  amount: i.amount,
                              };
                          })
                        : [];

                    const arr2 = [...arr];
                    arr1.forEach(i => {
                        [...arr].forEach((k, ki) => {
                            if (k.name == i.name) {
                                arr2[ki] = i;
                            }
                        });
                    });
                    form.setFieldsValue({
                        name,
                        identityDesc,
                        benefits: arr2,
                        id,
                    });
                    setAddDentity(true);
                }
            }
        });
    };

    // 权益列表
    const getConferenceIdentitySupplies = () => {
        getConferenceIdentitySuppliesApi({ activityId: cid, activityType: 'conference' }).then(res => {
            if (res && res.status_code === 200) {
                setData(res?.data);
            }
        });
    };

    // 新增 || 编辑 身份
    const handleAdd = (type, value) => {
        setType(type);
        if (type === 'edit') {
            setCurrentIdentity(value);
        } else {
            setCurrentIdentity({});
        }
        getSuppliesPage(type, value);
    };

    // 删除身份
    const handleDelete = row => {
        Modal.confirm({
            title: '提示',
            icon: <i className="bi bi-exclamation-circle"></i>,
            content: `确认是否删除该身份`,
            okText: '确认',
            centered: true,
            cancelText: '取消',
            onOk: () => {
                deleteActivityidentitiesApi({ id: row.id }).then(res => {
                    if (res && res.status_code === 200) {
                        message.success('删除成功！');
                        getActivityIdentities();
                    }
                });
            },
        });
    };

    // 删除模板
    const handleDeleteTemplate = row => {
        Modal.confirm({
            title: '提示',
            icon: <i className="bi bi-exclamation-circle"></i>,
            content: `确认是否删除该模板`,
            okText: '确认',
            centered: true,
            cancelText: '取消',
            onOk: () => {
                deleteActivityregistrationsApi({ id: row.id }).then(res => {
                    if (res && res.status_code === 200) {
                        message.success('删除成功！');
                        getActivityregistrations();
                    }
                });
            },
        });
    };
    const handleCancelAddDentity = () => {
        form.resetFields();
        setAddDentity(false);
    };

    // 保存身份
    const handleAddDentity = () => {
        form.validateFields().then(value => {
            // antd v6 validateFields 不包含 Form.List 未注册子项（如 id/name），从 store 取完整值
            const fullBenefits = form.getFieldValue('benefits') || [];
            const arr1 = fullBenefits.filter(i => i.check);
            const query = {
                identityDesc: value.identityDesc,
                name: value.name,
                benefits: JSON.stringify(arr1),
                activityId: cid,
                activityType: 'conference',
            };
            if (type === 'edit') query.id = ~~form.getFieldValue('id');
            const reqApi = type === 'edit' ? updateActivityidentitiesApi : saveActivityidentitiesApi;
            reqApi(query).then(res => {
                if (res && res.status_code === 200) {
                    message.success(`${type === 'edit' ? '编辑成功！' : '新增成功！'}`);
                    form.resetFields();
                    setAddDentity(false);
                    getActivityIdentities();
                }
            });
        });
    };

    // 新增、编辑权益
    const handleAddEquity = (type, value) => {
        if (type === 'add') {
            setSignTitle('新增报名权益');
        } else {
            setSignTitle('编辑报名权益');
            equityForm.setFieldsValue({
                name: value.name,
                amount: value.amount,
                id: value.id,
            });
        }
        setAddEquity(true);
    };

    const handleCancelEquity = () => {
        equityForm.resetFields();
        setAddEquity(false);
    };

    // 保存 || 编辑权益
    const handleSaveEquity = type => {
        equityForm.validateFields().then(async values => {
            const reqParams = {
                ...values,
                activityId: params?.id,
                activityType: 'conference',
                id: equityForm.getFieldValue('id') || undefined,
            };
            const reqApi = equityForm.getFieldValue('id') ? updateConferenceIdentitySuppliesApi : saveConferenceIdentitySuppliesApi;
            const res = await reqApi(reqParams);
            if (res && res.status_code === 200) {
                message.success('保存成功');
                getConferenceIdentitySupplies();
                equityForm.resetFields();
                if (type !== 'next') {
                    setAddEquity(false);
                }
            }
        });
    };

    // 删除权益
    const handleDeleteEquity = row => {
        Modal.confirm({
            title: '提示',
            icon: <i className="bi bi-exclamation-circle"></i>,
            content: `确认是否删除该权益`,
            okText: '确认',
            centered: true,
            cancelText: '取消',
            onOk: () => {
                deleteConferenceIdentitySuppliesApi({ id: row.id }).then(res => {
                    if (res && res.status_code === 200) {
                        message.success('删除成功！');
                        getConferenceIdentitySupplies();
                    }
                });
            },
        });
    };

    const handleGenerateChannel = row => {
        setGenerateChannelOpen(true);
        channelForm.setFieldValue('regId', row.id);
    };

    // 下载二维码
    const downloadQRCode = url => {
        const path = encodeURIComponent(url);
        const downUrl = `${config.API_PREFIX}/dataengine/api/mp/wxacode/dowload?env_version=${window.location.origin.includes('stage-') || window.location.origin.includes('test-') ? 'trial' : 'release'}&path=${path}`;
        window.open(downUrl);
    };

    //新增报名模板
    const handleAddTemplate = (type, value) => {
        if (type === 'add') {
            navigate(`/conf/conferences/${cid}/signup-template/add`);
        } else {
            navigate(`/conf/conferences/${cid}/signup-template/${value.id}/edit`);
        }
    };

    // 报名身份列表
    const getActivityIdentities = () => {
        getActivityIdentitiesApi({ activityId: cid, activityType: 'conference' }).then(res => {
            if (res && res.status_code === 200) {
                setActivityidentities(res.data);
            }
        });
    };

    // 报名模板列表
    const getActivityregistrations = () => {
        activityregistrationsApi({ activityId: cid, activityType: 'conference' }).then(res => {
            if (res && res.status_code === 200) {
                setActivityRegistrations(res.data);
            }
        });
    };

    // 获取小程序二维码图片
    const getWxCodeImage = async chanId => {
        const regId = channelForm.getFieldValue('regId');
        const link = `pages/activity/register?confid=${cid}&regid=${regId}&chid=${chanId}`;
        const params = {
            env_version: window.location.origin.includes('stage-') || window.location.origin.includes('test-') ? 'trial' : 'release',
            path: link,
            width: 300,
        };
        const url = `${config.API_PREFIX}/dataengine/api/mp/getwxacode`;
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=utf-8' },
            body: JSON.stringify(params),
        });

        if (response.ok) {
            const text = await response.text();
            setWxacode(text);
        }
    };

    // 报名渠道列表
    const getChannelList = () => {
        getChannelListApi({ page: 1, limit: 9999 }).then(res => {
            if (res && res.status_code === 200 && res.data) {
                let channels = Array.isArray(res.data.list) ? res.data.list : [];
                channels = [{ ...DefaultChannel }, ...channels];
                setChannelList(channels);
            }
        });
    };

    useEffect(() => {
        if (!!channelId || channelId === 0) {
            getWxCodeImage(channelId);
        }
    }, [channelId]);

    useEffect(() => {
        getConferenceIdentitySupplies();
        getActivityIdentities();
        getActivityregistrations();
        getChannelList();
    }, []);

    return (
        <>
            <div className="signup-setting">
                <div className="table-wrap">
                    <div className="signup-form-subtitle sign-up-setting-title">报名权益</div>
                    <Button icon={<i className="bi bi-plus"></i>} className="add-btn" onClick={() => handleAddEquity('add')}>
                        新增报名权益
                    </Button>
                    <Table rowKey={r => r.id} columns={signColumns} dataSource={data} pagination={false} size="small" />
                </div>

                <div className="table-wrap">
                    <div className="signup-form-subtitle">报名身份</div>
                    <Button icon={<i className="bi bi-plus"></i>} className="add-btn" onClick={() => handleAdd('add')}>
                        新增报名身份
                    </Button>
                    <Table rowKey={r => r.id} columns={columns} dataSource={activityidentities} pagination={false} size="small" />
                </div>

                <div className="table-wrap">
                    <div className="signup-form-subtitle">报名模板</div>
                    <Button icon={<i className="bi bi-plus"></i>} className="add-btn" onClick={() => handleAddTemplate('add')}>
                        新增报名模板
                    </Button>
                    <Table rowKey={r => r.id} columns={templateColumns} dataSource={activityRegistrations} pagination={false} size="small" />
                </div>
            </div>

            <Modal
                title={type === 'edit' ? '编辑身份' : '新建身份'}
                open={addDentity}
                destroyOnHidden={true}
                centered
                width={700}
                mask={{ closable: false }}
                onCancel={handleCancelAddDentity}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Space>
                            <Button onClick={handleCancelAddDentity}>取消</Button>
                            <Button type="primary" htmlType="submit" onClick={handleAddDentity}>
                                确定
                            </Button>
                        </Space>
                    </div>
                }
            >
                <Form form={form} {...pageFormItemLayout}>
                    <Form.Item
                        name="name"
                        label="身份名称"
                        className="sign-wp-setting-form"
                        rules={[
                            { required: true, message: '身份名称不能为空' },
                            { min: 2, message: '请输入2-15个字符' },
                        ]}
                        tooltip={currentIdentity.createdBy === '系统' ? '此身份名称不支持修改' : ''}
                    >
                        <Input maxLength={15} showCount placeholder="请输入身份名称" disabled={currentIdentity.createdBy === '系统'}></Input>
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            return (
                                !!form.getFieldValue('benefits')
                                && !!form.getFieldValue('benefits').length && (
                                    <Form.Item name="benefits" label="身份权益">
                                        <Form.List name="benefits">
                                            {(fields, { add, remove }) => (
                                                <Fragment>
                                                    {fields.map(({ key, name, ...restFields }, index) => (
                                                        <div key={index} style={{ display: 'flex', marginBottom: 10 }}>
                                                            <Form.Item {...restFields} name={[name, 'check']} style={{ marginBottom: 0 }} valuePropName="checked">
                                                                <Checkbox style={{ width: 160 }}>{form.getFieldValue('benefits')[index].name}</Checkbox>
                                                            </Form.Item>
                                                            {form.getFieldValue('benefits')[index].check && (
                                                                <Form.Item
                                                                    {...restFields}
                                                                    className="sign-up-form-item-count"
                                                                    name={[name, 'amount']}
                                                                    label={`${form.getFieldValue('benefits')[index].name}数量`}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            validator: async (rule, value) => {
                                                                                if (form.getFieldValue('benefits')[index].check && (!/^\+?[0-9]\d*$/.test(value) || value === '0')) {
                                                                                    throw '请输入正整数';
                                                                                }
                                                                            },
                                                                        },
                                                                    ]}
                                                                    style={{ marginBottom: 0, marginLeft: 30 }}
                                                                >
                                                                    <Input placeholder="请输入" style={{ width: 100 }} />
                                                                </Form.Item>
                                                            )}
                                                        </div>
                                                    ))}
                                                </Fragment>
                                            )}
                                        </Form.List>
                                    </Form.Item>
                                )
                            );
                        }}
                    </Form.Item>

                    <Form.Item name="identityDesc" label="说明">
                        <Input.TextArea autoSize={{ minRows: 3, maxRows: 5 }} maxLength={100} showCount></Input.TextArea>
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title={signTitle}
                open={addEquity}
                destroyOnHidden={true}
                centered
                width={500}
                mask={{ closable: false }}
                onCancel={handleCancelEquity}
                footer={
                    signTitle === '编辑报名权益' ? (
                        <div style={{ textAlign: 'right' }}>
                            <Space>
                                <Button onClick={handleCancelEquity}>取消</Button>
                                <Button type="primary" htmlType="submit" onClick={handleSaveEquity}>
                                    确定
                                </Button>
                            </Space>
                        </div>
                    ) : (
                        <div style={{ textAlign: 'right' }}>
                            <Space>
                                <Button type="primary" htmlType="submit" onClick={handleSaveEquity}>
                                    确定
                                </Button>
                                <Button type="primary" onClick={() => handleSaveEquity('next')}>
                                    确定并新增下一个权益
                                </Button>
                            </Space>
                        </div>
                    )
                }
            >
                <Form form={equityForm} {...pageFormItemLayout}>
                    <Form.Item
                        name="name"
                        label="权益名称"
                        className="sign-wp-setting-form"
                        rules={[
                            { required: true, message: '请输入权益名称' },
                            { min: 2, message: '请输入2-25个字符' },
                        ]}
                    >
                        <Input placeholder="请输入权益名称" maxLength={25} showCount />
                    </Form.Item>
                    <Form.Item name="amount" label="权益数量" className="sign-wp-setting-form">
                        <InputNumber min={0} placeholder="请输入权益数量" />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="生成渠道码"
                open={generateChannelOpen}
                destroyOnHidden={true}
                centered
                width={500}
                mask={{ closable: false }}
                onCancel={() => {
                    setGenerateChannelOpen(false);
                    channelForm.resetFields();
                }}
                footer={null}
            >
                <Form form={channelForm} {...pageFormItemLayout}>
                    <Form.Item name="channelId" label="报名渠道" className="sign-wp-setting-form">
                        <Select placeholder="请选择报名渠道" options={channelList} fieldNames={{ label: 'title', value: 'id' }} showSearch={{ filterOption: (input, option) => (option?.title ?? '').toLowerCase().includes(input.toLowerCase()) }} />
                    </Form.Item>
                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            const channelId = getFieldValue('channelId');
                            const regId = getFieldValue('regId');
                            const link = `pages/activity/register?confid=${cid}&regid=${regId}&chid=${channelId}`;
                            return (
                                (!!channelId || channelId === 0) && (
                                    <>
                                        <Form.Item label="渠道小程序码" className="sign-wp-setting-form">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div className="mini_program_wrap">
                                                    <Image src={wxacode} width={120} alt="报名小程序码" />
                                                </div>
                                                <Button type="primary" onClick={() => downloadQRCode(link)}>
                                                    下载二维码
                                                </Button>
                                            </div>
                                        </Form.Item>
                                    </>
                                )
                            );
                        }}
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default SignUpSetting;
